export const COLORS = {
  commonBackGroundPrimary: "#0d142f",
  commonButtonPrimary: "#f5a619",
  commonButtonSecondary: "#78e5ff",
  commonTextLight: "#f0f3f4",
  commonTextDark: "#0d142f",
  commonLightBorder: "#363d5a",
  gameCardBackgroud: "#121b3d",
};
